export default __webpack_public_path__ + "static/media/img7.a437afbc.PNG";